import { reportOnce } from '@protector/api-client';
import type { AvailableWorkspace, LicensingStatusAppsResponse } from '../company/models.ts';
import { PLANS_PAGE_SIZE, type Entitlements } from './constants.ts';
import type { AppPlan, AppPlansResponse } from './models.ts';

export const getEntitledWorkspaceIds = (workspaces: AvailableWorkspace[], entitledPlanIds: Set<string>): Set<string> => {
  const entitledWorkspaces = workspaces.filter(({ contracts }) =>
    contracts?.some(({ plan_id, is_active }) => is_active === true && entitledPlanIds.has(plan_id))
  );

  return new Set(entitledWorkspaces.map(({ id }) => id));
};

export const hasEntitlements = (app: LicensingStatusAppsResponse, entitlements: Entitlements[]): boolean => {
  return app.plan.entitlements.some(appEntitlement => entitlements.includes(appEntitlement.key));
};

export const getPlanIdsWithEntitlement = (plans: AppPlan[], entitlement: Entitlements): Set<string> => {
  const planIds = plans.filter(plan => plan.entitlements?.some(({ key }) => key === entitlement)).map(({ id }) => id);

  return new Set(planIds);
};

export const selectEntitledPlanIds = (response: AppPlansResponse, entitlement: Entitlements): Set<string> => {
  if (response.last === false) {
    reportOnce(
      'licensing.utils:protector-plans-truncated',
      () =>
        new Error(`licensing.utils: the plans response carries more than ${PLANS_PAGE_SIZE} plans, so the entitled plan set is truncated`),
      { errorType: 'StateFallback', domain: 'VisitDashboard' }
    );
  }

  return getPlanIdsWithEntitlement(response.content ?? [], entitlement);
};
